// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Shared CRUD Page Layout (aligned with PendingUpdatesPage) =====
   Import this in every CRUD page for consistent alignment, spacing, and structure. */

.crud-page {
  padding: 28px 32px;
  max-width: 1400px;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif;
}

/* --- Header --- */
.crud-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 28px;
}

.crud-header-text h1 {
  font-size: 26px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 6px 0;
}

.crud-header-text p {
  color: #6b7280;
  margin: 0;
  font-size: 15px;
}

/* --- Primary / Ghost Buttons --- */
.crud-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  padding: 10px 20px;
}

.crud-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.crud-btn-primary {
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: #fff;
  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.3);
}

.crud-btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35);
}

.crud-btn-ghost {
  background: #f3f4f6;
  color: #4b5563;
  border: 1px solid #e5e7eb;
}

.crud-btn-ghost:hover {
  background: #e5e7eb;
}

.crud-btn-icon {
  font-size: 18px;
  line-height: 1;
}

/* --- Toasts --- */
.crud-toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 10px;
  margin-bottom: 20px;
  font-size: 15px;
  animation: crudSlideIn 0.25s ease;
}

.crud-toast button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: inherit;
  padding: 0 4px;
  opacity: 0.7;
}

.crud-toast-error {
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
}

.crud-toast-success {
  background: #ecfdf5;
  color: #065f46;
  border: 1px solid #a7f3d0;
}

@keyframes crudSlideIn {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
}

/* --- Stats Grid --- */
.crud-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 28px;
}

.crud-stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.crud-stat-icon {
  font-size: 20px;
}

.crud-stat-value {
  font-size: 28px;
  font-weight: 800;
  color: #111827;
  line-height: 1.1;
}

.crud-stat-label {
  font-size: 15px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* --- Loading / Empty --- */
.crud-loading {
  text-align: center;
  padding: 60px 20px;
  color: #6b7280;
}

.crud-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e5e7eb;
  border-top-color: #3b82f6;
  border-radius: 50%;
  margin: 0 auto 16px;
  animation: crudSpin 0.8s linear infinite;
}

@keyframes crudSpin {
  to { transform: rotate(360deg); }
}

.crud-empty {
  text-align: center;
  padding: 60px 20px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.crud-empty-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

.crud-empty h3 {
  font-size: 18px;
  color: #374151;
  margin: 0 0 6px 0;
}

.crud-empty p {
  color: #6b7280;
  font-size: 15px;
  margin: 0 0 20px 0;
}

/* --- Table Wrapper & Table --- */
.crud-table-wrap {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.crud-table {
  width: 100%;
  border-collapse: collapse;
}

.crud-table thead th {
  background: #f8fafc;
  padding: 14px 16px;
  text-align: left;
  font-size: 15px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #e2e8f0;
}

.crud-table tbody td {
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 15px;
  color: #334155;
  vertical-align: middle;
}

.crud-table tbody tr:last-child td {
  border-bottom: none;
}

.crud-table tbody tr:hover {
  background: #f8fafc;
}

/* --- Pagination --- */
.crud-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px 0;
  margin-top: 8px;
}

.crud-pagination-btn {
  padding: 10px 18px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #4b5563;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}

.crud-pagination-btn:hover:not(:disabled) {
  background: #e5e7eb;
  border-color: #d1d5db;
}

.crud-pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.crud-pagination-info {
  font-size: 15px;
  color: #6b7280;
  font-weight: 500;
}

/* --- Modal --- */
.crud-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: crudFadeIn 0.2s ease;
}

@keyframes crudFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.crud-modal {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 560px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18);
  animation: crudSlideUp 0.25s ease;
}

@keyframes crudSlideUp {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}

.crud-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 28px 0;
}

.crud-modal-header h2 {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.crud-modal-close {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.crud-modal-close:hover {
  background: #e5e7eb;
  color: #111827;
}

.crud-form-section {
  padding: 0 28px;
  margin-top: 20px;
}

.crud-label {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.crud-input {
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #d1d5db;
  border-radius: 8px;
  font-size: 15px;
  color: #1f2937;
  transition: border-color 0.15s;
  background: #fff;
  box-sizing: border-box;
}

.crud-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.crud-modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 20px 28px 24px;
  margin-top: 8px;
  border-top: 1px solid #f1f5f9;
}

/* --- Danger icon button (e.g. delete row) --- */
.crud-btn-danger-sm {
  width: 34px;
  height: 34px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #fecaca;
  background: #fef2f2;
  color: #dc2626;
  cursor: pointer;
  font-size: 15px;
  transition: all 0.15s;
}

.crud-btn-danger-sm:hover:not(:disabled) {
  background: #dc2626;
  color: #fff;
  border-color: #dc2626;
}

.crud-btn-danger-sm:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

/* --- Responsive --- */
@media (max-width: 768px) {
  .crud-page {
    padding: 16px;
  }
  .crud-stats {
    grid-template-columns: repeat(2, 1fr);
  }
  .crud-header {
    flex-direction: column;
    gap: 12px;
  }
  .crud-modal {
    max-width: calc(100% - 32px);
    margin: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CrudPage.css"],"names":[],"mappings":"AAAA;qFACqF;;AAErF;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,+EAA+E;AACjF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,wEAAwE;EACxE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wEAAwE;EACxE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;AAC/B;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE;IACE,aAAa;EACf;EACA;IACE,qCAAqC;EACvC;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,4BAA4B;IAC5B,YAAY;EACd;AACF","sourcesContent":["/* ===== Shared CRUD Page Layout (aligned with PendingUpdatesPage) =====\n   Import this in every CRUD page for consistent alignment, spacing, and structure. */\n\n.crud-page {\n  padding: 28px 32px;\n  max-width: 1400px;\n  margin: 0 auto;\n  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif;\n}\n\n/* --- Header --- */\n.crud-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 28px;\n}\n\n.crud-header-text h1 {\n  font-size: 26px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 6px 0;\n}\n\n.crud-header-text p {\n  color: #6b7280;\n  margin: 0;\n  font-size: 15px;\n}\n\n/* --- Primary / Ghost Buttons --- */\n.crud-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  padding: 10px 20px;\n}\n\n.crud-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.crud-btn-primary {\n  background: linear-gradient(135deg, #2563eb, #3b82f6);\n  color: #fff;\n  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.3);\n}\n\n.crud-btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35);\n}\n\n.crud-btn-ghost {\n  background: #f3f4f6;\n  color: #4b5563;\n  border: 1px solid #e5e7eb;\n}\n\n.crud-btn-ghost:hover {\n  background: #e5e7eb;\n}\n\n.crud-btn-icon {\n  font-size: 18px;\n  line-height: 1;\n}\n\n/* --- Toasts --- */\n.crud-toast {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-radius: 10px;\n  margin-bottom: 20px;\n  font-size: 15px;\n  animation: crudSlideIn 0.25s ease;\n}\n\n.crud-toast button {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: inherit;\n  padding: 0 4px;\n  opacity: 0.7;\n}\n\n.crud-toast-error {\n  background: #fef2f2;\n  color: #991b1b;\n  border: 1px solid #fecaca;\n}\n\n.crud-toast-success {\n  background: #ecfdf5;\n  color: #065f46;\n  border: 1px solid #a7f3d0;\n}\n\n@keyframes crudSlideIn {\n  from { opacity: 0; transform: translateY(-8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* --- Stats Grid --- */\n.crud-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 14px;\n  margin-bottom: 28px;\n}\n\n.crud-stat-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 18px 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.crud-stat-icon {\n  font-size: 20px;\n}\n\n.crud-stat-value {\n  font-size: 28px;\n  font-weight: 800;\n  color: #111827;\n  line-height: 1.1;\n}\n\n.crud-stat-label {\n  font-size: 15px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* --- Loading / Empty --- */\n.crud-loading {\n  text-align: center;\n  padding: 60px 20px;\n  color: #6b7280;\n}\n\n.crud-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #e5e7eb;\n  border-top-color: #3b82f6;\n  border-radius: 50%;\n  margin: 0 auto 16px;\n  animation: crudSpin 0.8s linear infinite;\n}\n\n@keyframes crudSpin {\n  to { transform: rotate(360deg); }\n}\n\n.crud-empty {\n  text-align: center;\n  padding: 60px 20px;\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.crud-empty-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n}\n\n.crud-empty h3 {\n  font-size: 18px;\n  color: #374151;\n  margin: 0 0 6px 0;\n}\n\n.crud-empty p {\n  color: #6b7280;\n  font-size: 15px;\n  margin: 0 0 20px 0;\n}\n\n/* --- Table Wrapper & Table --- */\n.crud-table-wrap {\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n}\n\n.crud-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.crud-table thead th {\n  background: #f8fafc;\n  padding: 14px 16px;\n  text-align: left;\n  font-size: 15px;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.crud-table tbody td {\n  padding: 14px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 15px;\n  color: #334155;\n  vertical-align: middle;\n}\n\n.crud-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.crud-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n/* --- Pagination --- */\n.crud-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 24px 0;\n  margin-top: 8px;\n}\n\n.crud-pagination-btn {\n  padding: 10px 18px;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  color: #4b5563;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.crud-pagination-btn:hover:not(:disabled) {\n  background: #e5e7eb;\n  border-color: #d1d5db;\n}\n\n.crud-pagination-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.crud-pagination-info {\n  font-size: 15px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n/* --- Modal --- */\n.crud-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: crudFadeIn 0.2s ease;\n}\n\n@keyframes crudFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.crud-modal {\n  background: #fff;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 560px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18);\n  animation: crudSlideUp 0.25s ease;\n}\n\n@keyframes crudSlideUp {\n  from { opacity: 0; transform: translateY(16px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.crud-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 28px 0;\n}\n\n.crud-modal-header h2 {\n  font-size: 20px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n}\n\n.crud-modal-close {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: none;\n  background: #f3f4f6;\n  color: #6b7280;\n  font-size: 20px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.crud-modal-close:hover {\n  background: #e5e7eb;\n  color: #111827;\n}\n\n.crud-form-section {\n  padding: 0 28px;\n  margin-top: 20px;\n}\n\n.crud-label {\n  display: block;\n  font-size: 15px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.crud-input {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 15px;\n  color: #1f2937;\n  transition: border-color 0.15s;\n  background: #fff;\n  box-sizing: border-box;\n}\n\n.crud-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);\n}\n\n.crud-modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  padding: 20px 28px 24px;\n  margin-top: 8px;\n  border-top: 1px solid #f1f5f9;\n}\n\n/* --- Danger icon button (e.g. delete row) --- */\n.crud-btn-danger-sm {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  border: 1px solid #fecaca;\n  background: #fef2f2;\n  color: #dc2626;\n  cursor: pointer;\n  font-size: 15px;\n  transition: all 0.15s;\n}\n\n.crud-btn-danger-sm:hover:not(:disabled) {\n  background: #dc2626;\n  color: #fff;\n  border-color: #dc2626;\n}\n\n.crud-btn-danger-sm:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n/* --- Responsive --- */\n@media (max-width: 768px) {\n  .crud-page {\n    padding: 16px;\n  }\n  .crud-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .crud-header {\n    flex-direction: column;\n    gap: 12px;\n  }\n  .crud-modal {\n    max-width: calc(100% - 32px);\n    margin: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
